import React from 'react';
import {
  Tile,
  TileContent,
  TileStateIndicator,
} from '@one-thd/sui-atomic-components';
import ItemImage from '@src/components/shared/items/ItemImage';
import { ItemToReturn } from '@src/models/returns';
import ItemDescription from '../shared/items/ItemDescription';
import ItemQuantityCostRow from '../shared/items/ItemQuantityCostRow';

interface DisabledItemProps {
  item: ItemToReturn;
}

export const DisabledItem = ({ item }: DisabledItemProps) => {
  return (
    <div
      key={item.sku}
      className="sui-flex md:sui-gap-32 md:sui-justify-between sui-mb-4"
      data-testid="disabled-item"
    >
      <div className="sui-flex sui-w-full sui-gap-4">
        <Tile disabled>
          <TileContent>
            <TileStateIndicator />
            <ItemImage
              itemDescription={item?.itemDescription}
              imageUrl={item?.itemImageURL}
              marginY
            />
            <div className="sui-flex-col sui-ml-2">
              <ItemDescription
                brandName={item?.brandName}
                itemDescription={item?.itemDescription}
                fullWidth
                noMargin
              />
              <ItemQuantityCostRow
                quantity={item?.currentQuantity}
                cost={item?.itemCost}
              />
            </div>
          </TileContent>
        </Tile>
      </div>
    </div>
  );
};
